// Deletes the service worker's runtime caches (kz-* in pwa/sw.js) and anything
// left by the old sw-toolbox worker, which cached per-user HTML. The Workbox
// precache stays: it holds only the build and the offline page.
export default function clearRuntimeCaches (): Promise<any> {
  if (typeof window === 'undefined' || !('caches' in window)) return Promise.resolve()
  return window.caches.keys()
    .then(keys => Promise.all(keys
      .filter(key => key.startsWith('kz-') || key.startsWith('sw-precache-') || key.includes('$$$toolbox-cache$$$'))
      .map(key => window.caches.delete(key))))
    .catch(() => {})
}
